export const SERVER_ENDPOINT = process.env.REACT_APP_BASE_URL;
export const BASE_API = SERVER_ENDPOINT;

export const AUTH_BASE_URL = SERVER_ENDPOINT;
export const BI_BASE_URL = `${SERVER_ENDPOINT}/bi/api/v1`;
export const PANEl_BASE_URL = `${SERVER_ENDPOINT}/accounts/api/v2`;
